export const JALALI_DATE_TIME_FORMAT = "jYYYY/jMM/jDD - HH:mm";
